import * as React from 'react';
import { ResponsiveImage } from 'lib/types';
import { EmployeeImageWithModal } from '../components/EmployeeView';
import type { Employee } from '../components/EmployeeView';

export default function useEmployeeModalImages(
    employee?: Employee,
): null | ResponsiveImage {
    return React.useMemo(() => {
        if (employee?.image) {
            const { mobile, desktop, mobileModal, desktopModal } =
                employee.image as EmployeeImageWithModal;

            if (mobileModal && desktopModal) {
                return {
                    mobile: mobileModal,
                    desktop: desktopModal,
                };
            }

            if (mobile && desktop) {
                return { mobile, desktop };
            }
        }

        return null;
    }, [employee?.image]);
}
